class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		const facetForm = this.querySelector('form');
		facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener('popstate', onHistoryChange);
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{html, url},
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		const updateFilterOpenEvent = new CustomEvent('renderProductGrid', {
			bubbles: true,
			detail: {
				newOpenList: null,
				newfacetsRemove: null,
			},
		});

		document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductGridContainer').innerHTML;

		updateFilterOpenEvent.detail.newOpenList = document.querySelectorAll(
			'.js-filter-panel-open',
		);
		updateFilterOpenEvent.detail.newfacetsRemove = document.querySelector(
			'.js-slider-facet-remove',
		);
		document.dispatchEvent(updateFilterOpenEvent);
	}

	static renderProductCount(html) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		// Garde-fous : selon la page (collection, recherche) et l'état des
		// résultats, ces éléments peuvent être absents du HTML fetché.
		const count = parsedHTML.getElementById('ProductCount');
		const container = document.getElementById('ProductCount');
		if (count && container) container.innerHTML = count.innerHTML;

		const productCountJson = parsedHTML.getElementById(
			'product-count-content-json',
		);
		const ProductCountDesciption = document.getElementById(
			'product-count-description',
		);
		if (!productCountJson || !ProductCountDesciption) return;

		const ProductCountDesciptionContent = JSON.parse(
			productCountJson.textContent,
		).product_count_content;
		if (ProductCountDesciptionContent) {
			ProductCountDesciption.innerHTML = ProductCountDesciptionContent;
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const updateDetailsAnimationEvent = new CustomEvent(
			'update-details-animation',
			{
				bubbles: true,
				detail: {
					newDetailsEl: null,
					isPriceDetails: false,
				},
			},
		);

		const facetDetailsElements = parsedHTML.querySelectorAll(
			'#FacetFiltersPanelForm .js-detail-facet',
		);

		const matchesIndex = (element) => {
			const jsFilter = event
				? event.target.closest('.js-detail-facet')
				: undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element),
		);

		facetsToRender.forEach((element) => {
			document.querySelector(
				`.js-detail-facet[data-index="${element.dataset.index}"]`,
			).innerHTML = element.innerHTML;

			if (element.dataset.isPriceDetails) {
				updateDetailsAnimationEvent.detail.isPriceDetails = true;
			} else {
				updateDetailsAnimationEvent.detail.isPriceDetails = false;
			}

			updateDetailsAnimationEvent.detail.newDetailsEl = document.querySelector(
				`.js-detail-facet[data-index="${element.dataset.index}"]`,
			);
			document.dispatchEvent(updateDetailsAnimationEvent);
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			'.active-facets-mobile',
			'.active-facets-desktop',
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			if (document.querySelector(selector)) {
				document.querySelector(selector).innerHTML =
					activeFacetsElement.innerHTML;
			}
		});
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{searchParams},
			'',
			`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);

		for (let [name, value] of Array.from(formData.entries())) {
			if (value === '') {
				formData.delete(name);
			}
		}

		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const currentForm = event.target.closest('form');
		const forms = [];

		if (currentForm.id === 'FacetFiltersPanelForm') {
			const sortByform = document.getElementById('FacetSortDesktopForm');
			forms.push(this.createSearchParams(currentForm));
			forms.push(this.createSearchParams(sortByform));
		} else {
			const panelForm = document.getElementById('FacetFiltersPanelForm');
			forms.push(this.createSearchParams(currentForm));
			forms.push(this.createSearchParams(panelForm));
		}

		this.onSubmitForm(forms.join('&'), event);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		const url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf('?') + 1,
					);
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector('a');
		facetLink.setAttribute('role', 'button');
		facetLink.addEventListener('click', this.closeFilter.bind(this));
		facetLink.addEventListener('keyup', (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest('facet-filters-form') ||
			document.querySelector('facet-filters-form');
		form.onActiveFilterClick(event);
	}
}

customElements.define('facet-remove', FacetRemove);
